module.exports = __webpack_public_path__ + "img/btn-app-store.39ba3187.png";